export enum SPKAddPositionStepStatus {
  inProgress,
  completed,
  pending,
}

const SPKAddPositionStep = ({
  title,
  status,
}: {
  title: string;
  status: SPKAddPositionStepStatus;
}) => {
  return (
    <div className="flex flex-col items-center flex-1">
      <div
        className={`rounded-full w-full min-h-2 transition-colors delay-100 duration-500 ${
          status === SPKAddPositionStepStatus.completed && 'bg-spk-highContrast'
        }
        ${
          status === SPKAddPositionStepStatus.inProgress &&
          'bg-spk-neutral-30 border border-dashed border-employer-secondary'
        }
        ${
          status === SPKAddPositionStepStatus.pending && 'bg-employer-secondary'
        }
        `}
      />
      <span>{title}</span>
    </div>
  );
};

export default SPKAddPositionStep;
